import React from 'react'

const UserRankings = () => {
  return (
    <div>UserRankings</div>
  )
}

export default UserRankings